import React from "react";
import { useNavigate } from "react-router";
import { NavLink } from "react-router-dom";
import { superAdminLinks } from "../../utils/links";
import { userLinks } from "../../utils/links";
import "./Sidebar.css";
import UserNavlinks from "./UserNavlinks";

const Navlinks = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const role = JSON.parse(localStorage.getItem("userLoggedIn"))?.role_id;

  const handleLogout = () => {
    // localStorage.removeItem("userLoggedIn");
    localStorage.clear();
    navigate("/login");
  };

  if (role === 1) {
    return (
      <div className="nav-links">
        {superAdminLinks.map((link) => {
          const { text, path, id, icon } = link;

          return (
            <NavLink
              to={path}
              key={id}
              className={({ isActive }) =>
                isActive ? "active nav-link" : "nav-link"
              }
              onClick={toggleSidebar}
            >
              <span style={{ marginLeft: "-20px", paddingRight: "15px" }}>
                {icon}
              </span>
              {text}
            </NavLink>
          );
        })}
        <button
          style={{ background: "none", border: "none", cursor: "pointer" }}
          className="nav-link"
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    );
  }
  return (
    <UserNavlinks
      NavLink={NavLink}
      userLinks={userLinks}
      toggleSidebar={toggleSidebar}
      handleLogout={handleLogout}
    />
  );
};

export default Navlinks;
